import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(
        () => localStorage.getItem('isAuthenticated') === 'true'
    );
    const [loading, setLoading] = useState(true);

    
    useEffect(() => {
        // Simulate async auth check (replace with real auth check)
        const checkAuth = async () => {
            try {
                const storedAuth = localStorage.getItem('isAuthenticated');
                setIsAuthenticated(storedAuth === 'true');
            } catch (error) {
                console.error('Auth check failed:', error);
                setIsAuthenticated(false);
            } finally {
                setLoading(false); // Always set loading to false
            }
        };

        checkAuth();
    }, []);

    const login = () => {
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
    };

    const logout = () => {
        setIsAuthenticated(false);
        localStorage.removeItem('isAuthenticated');

    };

    const authContextValue = useMemo(() => ({
        isAuthenticated,
        login,
        logout,
        loading
    }), [isAuthenticated, login, logout, loading]);

    return (
        <AuthContext.Provider value={authContextValue}>
            {children}
        </AuthContext.Provider>
);
};
AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};


export const useAuth = () => useContext(AuthContext);

